import { Column } from './Column';

export class Cell extends Column {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public value: any;
  public isEditing: boolean;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  constructor(col: Column, value: any) {
    super({
      title: col.title,
      fieldName: col.fieldName,
      fieldType: col.fieldType,
      editable: col.editable,
      validator: col.validator,
      converter: col.converter,
      filterConverter: col.filterConverter,
      dropdownOptions: col.dropdownOptions,
      hidden: col.hidden,
      hiddenInAddDialog: col.hiddenInAddDialog,
      colStyling: col.colStyling,
      cellStyling: col.cellStyling,
      defaultValue: col.defaultValue
    });
    this.ordering = col.ordering;
    this.value = value;
    this.isEditing = false;
  }
}
